export function getCountryCode(countryName) {
	return countryName === 'MEXICO'
		? 'MLM'
		: countryName === 'COLOMBIA'
		? 'MLC'
		: countryName === 'BRASIL'
		? 'MLB'
		: 'MLA';
}
